import gql from "graphql-tag";

export const CREATE_STARTUP_MUTATION = gql`
  mutation CreateStartup($input: StartupInput!) {
    createStartup(input: $input) {
      statusCode
      message
    }
  }
`;
